import React from 'react'
import Loader from 'components/elements/coverLoader'
import BannerFeedback from '../../elements/bannerFeedback'
import { Modal, Button, Field } from '../../elements'
import { Formik, Form } from 'formik'

const AskQuestionToOwnerModal = (props) => {
  const {
    isModalOpen,
    handleModalClose,
    recipientName,
    recipientAvatar,
    onSendMessage,
    showError,
    setShowError,
  } = props

  const onSubmitHandler = (
    values,
    setFieldValue,
    setFieldError,
    setSubmitting
  ) => {
    if (!values.message) {
      setFieldError('message', 'Required')
      setSubmitting(false)
      return
    }
    onSendMessage(values.message, setSubmitting)
    setFieldValue('message', '')
  }

  return (
    <>
      <BannerFeedback
        showMessage={showError}
        messageContent="Sorry, we are having issues right now. Please try again."
        messageType="error"
        onDismiss={() => setShowError(false)}
      />
      <Modal
        show={isModalOpen}
        onClose={handleModalClose}
        showClose={true}
        header={`Ask ${recipientName} a Question`}
        closeOnBlur={true}
        closeOnEsc={true}
      >
        <>
          <div className="pt-5 pb-2 content has-black-dark-text">
            Some guidelines on Twisted Road messaging
            <ul>
              <li>
                Ask specific questions about the motorcycle, gear, or schedule
              </li>
              <li>Be polite</li>
              <li>
                Don't ask general questions about Twisted Road such as insurance
                or rider requirements. Those questions can be answered{' '}
                <a
                  className="has-text-weight-bold"
                  href="https://support.twistedroad.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{color:'#695626'}}
                >
                  here
                </a>
              </li>
              <li>
                <strong>Important:</strong> Rentals that occur outside the
                Twisted Road platform are NOT covered for damages or theft
              </li>
            </ul>
          </div>
          <Formik
            initialValues={{ message: '' }}
            onSubmit={(
              values,
              { setFieldError, setFieldValue, setSubmitting }
            ) =>
              onSubmitHandler(
                values,
                setFieldValue,
                setFieldError,
                setSubmitting
              )
            }
          >
            {({ errors, setFieldValue, isSubmitting, values }) => (
              <Form>
                {isSubmitting && <Loader text="Working..." />}
                <div className="is-flex mb-3">
                  <figure className="image is-48x48 is-inline-block mr-2">
                    <img
                      className="is-rounded"
                      alt="owner"
                      src={recipientAvatar}
                    />
                  </figure>
                  <Field
                    name="message"
                    id="message"
                    wrapClassName="is-flex-grow-1"
                    error={errors.message}
                    onChange={({ value }) => setFieldValue('message', value)}
                    value={values.message}
                    type="textarea"
                    placeholder="Type Your Message Here"
                    showErrors={true}
                    rows={2}
                    autoComplete="off"
                  />
                </div>
                <Button
                  color="primary"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  type="submit"
                  className="is-fullwidth"
                >
                  Send Message
                </Button>
              </Form>
            )}
          </Formik>
        </>
      </Modal>
    </>
  )
}

export default AskQuestionToOwnerModal
